import { Component, OnInit } from '@angular/core';
import { GuestService, RoleService, GuestRoleService } from 'app/shared/services';
import { Guest } from 'app/shared/models/guest.model';
import { Role } from 'app/shared/models/role.model';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { MatDialog } from '@angular/material/dialog';
import { IdentityMatchDialogComponent } from './identity-match-dialog/identity-match-dialog.component';
import { Router } from '@angular/router';
import { ValidationService } from 'app/shared/services/validation.service';
import { NotificationDialogComponent, ValidationResult } from 'app/shared';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-create-guest',
    templateUrl: './create-guest.component.html',
    styleUrls: ['./create-guest.component.scss'],
    standalone: false
})
export class CreateGuestComponent implements OnInit {
  guestRole: GuestRole = {} as GuestRole;
  roles!: Role[];
  validGuest: boolean = false;
  validRole: boolean = false;
  validSearch: boolean = false;
  spinner: boolean = false;
  guestValidation!: ValidationResult;

  constructor(private guestService: GuestService,
    private guestRoleService: GuestRoleService,
    private roleService: RoleService,
    private validationService: ValidationService,
    private dialog: MatDialog,
    private router: Router) { }

  ngOnInit() {
    this.guestRole = {} as GuestRole;
    this.guestRole.guest = {} as Guest;
    this.roleService.getRolesByUser().subscribe(
      result => {
        this.roles = result;
      }
    )
  }

  findPossibleMatchesForPerson(guest: Guest) {
    if ((guest.birthdate) !== undefined && guest.birthdate !== null) {
      this.spinner = true;
      this.guestService.getPotentialMatchingIdentities(
        this.guestRole.guest.lastName || '',
        this.guestRole.guest.firstName || '',
        this.guestRole.guest.birthdate
      ).subscribe({
        next: matches => {
          this.spinner = false;
          const dialogRef = this.dialog.open(IdentityMatchDialogComponent, {
            disableClose: true,
            width: '500px',
            data: { matches }
          });
          dialogRef.afterClosed().subscribe(
            result => {
              if (result == undefined) {
                return;
              } else if (result.action == 'new') {
                this.guestRole.guest.existingNotGuestAccount = false;
                this.guestRole.guest.canEditPerson = true;
                this.validSearch = true;
              } else if (result.action == 'match') {
                this.guestRole.guest.existingNotGuestAccount = true;
                this.guestRole.guest.canEditPerson = false;
                this.guestRole.guest.lastName = result.person.surname;
                this.guestRole.guest.firstName = result.person.restOfName;
                this.guestRole.guest.preferredName = result.person.preferredName;
                this.guestRole.guest.birthdate = result.person.birthdate;
                this.guestRole.guest.address = result.person.address;
                this.guestRole.guest.city = result.person.city;
                this.guestRole.guest.state = result.person.state;
                this.guestRole.guest.postalCode = result.person.postalCode;
                this.guestRole.guest.state = result.person.state;
                this.guestRole.guest.iNumber = result.person.iNumber;
                this.guestRole.guest.phone = result.person.phone;
                this.guestRole.guest.birthdate = result.person.birthdate;
                this.guestRole.guest.gender = result.person.gender;
                this.guestRole.guest.email = result.person.guestEmail;

                this.validSearch = true;
                this.validGuest = true;
              }

              if (this.roles.length == 1) {
                this.guestRole.roleId = this.roles[0].roleId
              }
            }
          )
        },
        error: e => this.spinner = false
      })
    }
  }

  validateEmail(): boolean {
    const regex = RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$');
    const valid = regex.test(this.guestRole.guest.email);
    return valid;
  }

  createGuestRole() {
    this.validRole = this.validationService.validateGuestRole(this.guestRole);
    this.guestValidation = this.validationService.validateGuest(this.guestRole.guest);
    // if (!this.validGuest || !this.validRole) {
    //   alert('Invalid. Please fill all required fields and resubmit.');
    //   return;
    // }
    if (!this.validRole) {
      alert('Invalid guest role, please fill all required field for the role and resubmit');
      return;
    }

    if (!this.guestValidation.isValid) {
      alert(this.guestValidation.reason);
      return
    }

    this.spinner = true;
    this.guestRoleService.createGuestRole(this.guestRole).subscribe({
      next: result => {
        let content;
        if (result.reason) {
          content = `Guest account successfully created with problems:\n${result.reason}`;
        } else {
          content = 'Guest account successfully created.';
        }
        this.dialog.open(NotificationDialogComponent, {
          disableClose: true,
          width: '500px',
          data: { title: "Guest Account Created", content: content }
        });
        this.spinner = false;
        this.router.navigate(['sponsor', 'manage', result.entity.guestRoleId])
      },
      error: (e: HttpErrorResponse) => {
        let message = 'Guest account creation failed.';
        if (e.status === 400) {
          message = e.error;
        }

        this.spinner = false;
        this.dialog.open(NotificationDialogComponent, {
          disableClose: true,
          width: '500px',
          data: { title: "Guest Account Creation Failed", content: message }
        });
      }//,
      //complete: () => // Do nothing else on completion.
    })
  }

  // TODO: I don't think this is ever used ... can it be removed, or do we need some of this logic elsewhere?
  // validateGuest() {
  //   // validate required fields
  //   const validationResult = this.validationService.validateGuest(this.guestRole.guest);
  //   if (validationResult.isValid) {
  //     this.spinner = true;

  //     // search for potentital identity matches
  //     this.guestService.getPotentialMatchingIdentities(
  //       this.guestRole.guest.lastName,
  //       this.guestRole.guest.firstName,
  //       this.guestRole.guest.birthdate
  //     ).subscribe({
  //       next: matches => {
  //         // display potential matches dialog
  //         if (matches.length > 0) {
  //           this.spinner = false;
  //           const dialogRef = this.dialog.open(IdentityMatchDialogComponent, {
  //             disableClose: true,
  //             width: '500px',
  //             data: { matches }
  //           });
  //           dialogRef.afterClosed().subscribe(
  //             result => {
  //               if (result == undefined) {
  //                 return;
  //               } else if (result.action == 'new') {
  //                 this.validGuest = true;
  //                 this.guestRole.guest.canEditPerson = true;
  //               } else if (result.action == 'match') {
  //                 this.guestRole.guest.canEditPerson = false;
  //                 this.guestRole.guest.lastName = result.person.surname;
  //                 this.guestRole.guest.firstName = result.person.restOfName;
  //                 this.guestRole.guest.preferredName = result.person.preferredName;
  //                 this.guestRole.guest.birthdate = result.person.birthdate;
  //                 this.guestRole.guest.address = result.person.address;
  //                 this.guestRole.guest.city = result.person.city;
  //                 this.guestRole.guest.state = result.person.state;
  //                 this.guestRole.guest.postalCode = result.person.postalCode;
  //                 this.guestRole.guest.state = result.person.state;
  //                 this.guestRole.guest.iNumber = result.person.iNumber;
  //                 this.guestRole.guest.phone = result.person.phone;
  //                 this.guestRole.guest.birthdate = result.person.birthdate;
  //                 this.guestRole.guest.gender = result.person.gender;
  //                 this.validGuest = true;
  //               }
  //             }
  //           )
  //         } else {
  //           this.spinner = false;
  //           this.validGuest = true;
  //         }
  //       },
  //       error: e => this.spinner = false
  //     })
  //   }
  // }
}
